<template lang="html">
  <router-link id="link" class="dib pointer no-underline" :to="route">
    <span class="flex items-center">
      <i v-if="iconPos === 'left' && iconCode"
        class="material-icons mr2"
        :class="iconClass"
      >{{ iconCode }}</i>
      <span class="h1 lh-title"
        :class="{
          'mr2': iconPos === 'left' && iconCode,
          'ml2': iconPos === 'right' && iconCode,
          'mh2': !iconCode
        }"
        v-html="label"
      />
      <i v-if="iconPos === 'right' && iconCode"
        class="material-icons ml2"
        :class="iconClass"
      >{{ iconCode }}</i>
    </span>
  </router-link>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'button',
      required: true
    },
    iconCode: {
      type: String,
      default: ''
    },
    iconPos: {
      type: String,
      default: 'left'
    },
    iconClass: {
      type: String,
      default: ''
    },
    route: {
      type: Object,
      default() {
        return {};
      },
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
#link:visited, #link:link {
  color: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/Link.vue